import React from "react";
import './amenities.scss'

const Amenities = () =>
{
	const amenities = [
		"🅿️ Parking Available",
		"🏊 Private Pool",
		"🌿 Garden Area",
		"🛋️ Fully Furnished",
		"👨‍👩‍👧 Family Friendly",
		"⚽ Turf",
		"📺 Smart TV",
		"🎤 Karaoke Sound System",
		"📽️ Projector",
		// "🔋 Inverter",
		"🔋 Inverter Backup"
	];
	
	return (
		<div className="amenities-section">
			<h2>Curated Amenities</h2>

			<div className="amenities-grid">
				{amenities.map((item, index) => (
					<div key={index} className="amenity-card">
						{item}
					</div>
				))}
			</div>
		</div>
	);
};

export default Amenities;